/*
  Monsor cross-sell flash + regel-highlight.

  De kaart blijft staan na toevoegen (geen server-side cartfilter in de snippet).
  Bij een klik op "Toevoegen":
   1. De knop toont kort "Toegevoegd" met vinkje (FLASH_MS) en keert dan terug.
   2. De bijbehorende winkelwagen-regel licht kort warm op en de prijs tikt op,
      zodat ook een ophoging (1 -> 2) duidelijk zichtbaar is.

  Het thema rendert de hele drawer opnieuw bij elke cart-wijziging. We koppelen
  via de variant-id en passen de staat na de herrender opnieuw toe.
*/
(function () {
  var FLASH_MS = 2200;
  var pending = null;      // { id, until, lineDone }
  var revertTimer = null;
  var savedScroll = 0;     // laatst bekende horizontale scrollpositie van de rij

  function drawer() {
    return document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
  }

  function clearAdded() {
    document.querySelectorAll('.monsor-cross__add.is-added').forEach(function (b) {
      b.classList.remove('is-added');
    });
    pending = null;
    if (revertTimer) { clearTimeout(revertTimer); revertTimer = null; }
  }

  function scheduleRevert() {
    if (revertTimer) clearTimeout(revertTimer);
    var ms = pending ? Math.max(0, pending.until - Date.now()) : 0;
    revertTimer = setTimeout(clearAdded, ms);
  }

  function applyButton() {
    if (!pending) return;
    if (Date.now() >= pending.until) { clearAdded(); return; }
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('.monsor-cross__add[data-variant-id="' + pending.id + '"]').forEach(function (b) {
      b.classList.add('is-added');
    });
    scheduleRevert();
  }

  function flashLine() {
    if (!pending || pending.lineDone) return;
    if (Date.now() >= pending.until) return;
    var d = drawer();
    if (!d) return;
    var li = d.querySelector('.horizontal-product[data-variant-id="' + pending.id + '"]');
    if (!li) return;
    pending.lineDone = true;
    li.classList.remove('monsor-line-flash');
    void li.offsetWidth;        // reflow zodat de animatie opnieuw start
    li.classList.add('monsor-line-flash');
    setTimeout(function () { li.classList.remove('monsor-line-flash'); }, 1800);
  }

  function wireArrow() {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('.monsor-cross').forEach(function (cross) {
      var track = cross.querySelector('.monsor-cross__track');
      var prev = cross.querySelector('.monsor-cross__prev');
      var next = cross.querySelector('.monsor-cross__next');
      if (!track) return;

      function step() {
        var card = track.querySelector('.monsor-cross__card');
        return card ? Math.round(card.getBoundingClientRect().width + 12) : Math.round(track.clientWidth * 0.8);
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 4;
        var sl = track.scrollLeft;
        // Het paar blijft staan zolang er iets te scrollen valt; de knop die
        // niets meer kan doen wordt gedimd in plaats van verborgen, zodat de
        // kop niet heen en weer schuift tijdens het scrollen.
        if (prev) {
          prev.hidden = !scrollable;
          prev.disabled = sl <= 4;
          prev.classList.toggle('is-off', sl <= 4);
        }
        if (next) {
          next.hidden = !scrollable;
          next.disabled = sl >= (max - 4);
          next.classList.toggle('is-off', sl >= (max - 4));
        }
      }
      if (!track.__monsorNavWired) {
        track.__monsorNavWired = true;
        track.addEventListener('scroll', function () { savedScroll = track.scrollLeft; update(); }, { passive: true });
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      }
      // Herstel de scrollpositie na een herrender, zodat de rij niet terugspringt.
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var target = Math.min(savedScroll, maxScroll);
      if (target > 0 && Math.abs(track.scrollLeft - target) > 1) {
        track.scrollLeft = target;
      }
      update();
    });
  }

  function react() { applyButton(); flashLine(); wireArrow(); }

  // Directe (optimistische) bevestiging + optellen bij bestaande regel.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('.monsor-cross__add[data-variant-id]') : null;
    if (!btn) return;
    var vid = String(btn.getAttribute('data-variant-id'));
    pending = { id: vid, until: Date.now() + FLASH_MS, lineDone: false };
    btn.classList.add('is-added');
    scheduleRevert();

    // Zit deze variant al als gewone (niet-gratis) regel in de mand? Dan tellen
    // we op via de bestaande plus-knop, zodat het samenvalt tot een regel i.p.v.
    // een tweede losse regel. Een gratis cadeau-regel slaan we over.
    var d = drawer();
    if (!d) return;
    var lines = d.querySelectorAll('.horizontal-product[data-variant-id="' + vid + '"]');
    for (var i = 0; i < lines.length; i++) {
      var li = lines[i];
      if (li.querySelector('.monsor-price-free')) continue;
      var plus = li.querySelector('button[name="plus"]');
      if (plus) {
        e.preventDefault();   // stop de losse toevoeging (product-form)
        plus.click();         // thema telt netjes op via de bestaande stepper
        return;
      }
    }
    // Geen bestaande gewone regel: product-form voegt gewoon een nieuwe regel toe.
  }, true);

  // Opnieuw toepassen nadat het thema de drawer heeft herrenderd.
  try {
    if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
      theme.pubsub.subscribe('cartUpdate', function (e) {
        if (e && e.productVariantId && pending == null) {
          pending = { id: String(e.productVariantId), until: Date.now() + FLASH_MS, lineDone: false };
          scheduleRevert();
        }
        setTimeout(react, 60);
        setTimeout(react, 400);
      });
    }
  } catch (_) {}

  function attachObserver() {
    var d = drawer();
    if (!d || d.__monsorCrossFlash) return;
    d.__monsorCrossFlash = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(react, 120);
    }).observe(d, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }

  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(wireArrow, 150); }, { passive: true });
  setTimeout(wireArrow, 300);
})();